var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-plot-chart-area"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.canvasTemplate)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.canvasTemplate)}})])}
var staticRenderFns = []

export { render, staticRenderFns }